import { system } from './theme'
import { grayRamp, blueRamp } from './tokens'

/**
 * [O4] The organizer turf map's opportunistic-stop palette. MapLibre paint (and the canvas-drawn
 * add-in diamond) need literal colours, so they are resolved from theme tokens HERE (the theme
 * directory is the style ratchet's colour home) and never typed as hex in a component — same
 * pattern as walkMapColors.ts. The map is light in both colour modes, so these are light values.
 *
 * gray/blue are mode-aware semantic tokens (dualRamp in theme.ts): `system.token` returns a CSS
 * var for them, which MapLibre cannot paint, so they resolve from their LIGHT base ramps.
 */
const LIGHT_RAMPS: Record<string, Record<string | number, string>> = { gray: grayRamp, blue: blueRamp }

const color = (token: string): string => {
  const [palette, step] = token.split('.')
  const v = (step !== undefined ? LIGHT_RAMPS[palette]?.[step] : undefined) ?? system.token(`colors.${token}`)
  if (typeof v !== 'string' || !v.startsWith('#')) throw new Error(`turfMapColors: no hex for ${token}`)
  return v
}

export const TURF_MAP_COLORS = {
  /** A suggested new stop ("ghost"), drawn translucent. */
  ghost: color('gray.500'),
  ghostText: color('white'),
  /** Add-in stops (violet diamond) and the "+N" extras badge. */
  addIn: color('purple.600'),
  addInStroke: color('white'),
  /** Numbered stops along the drive path. */
  route: color('orange.400'),
} as const
